import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HQ } from '../data/company';

const CITY = '/images/home/hero-city.webp';

/** Headquarters band for the footer: the cityscape under a navy wash, with the address and a pulsing marker. */
export default function FooterLocationCard() {
  const { t } = useTranslation();

  return (
    <div className="relative isolate overflow-hidden rounded-3xl border border-white/10 bg-[#0b1220] shadow-[0_30px_70px_-35px_rgba(0,102,255,0.55)]">
      <img src={CITY} alt="" width={2200} height={917} loading="lazy" className="absolute inset-0 -z-20 h-full w-full object-cover object-[78%_center]" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-[#0b1220] via-[#0b1220]/90 via-[42%] to-[#0b1220]/25" aria-hidden />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#0b1220]/70 via-transparent to-transparent" aria-hidden />
      <div className="pointer-events-none absolute -left-16 top-0 -z-10 h-64 w-64 rounded-full bg-[#1769ff]/25 blur-3xl" aria-hidden />

      {/* Marker over the city, large screens */}
      <div className="pointer-events-none absolute right-[16%] top-1/2 hidden -translate-y-1/2 lg:block" aria-hidden>
        <span className="absolute left-1/2 top-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 animate-ping rounded-full bg-[#1769ff]/40 [animation-duration:2.6s]" />
        <span className="absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/40" />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#1769ff] text-2xl text-white shadow-[0_0_0_6px_rgba(255,255,255,0.9),0_18px_40px_rgba(0,102,255,0.6)]">
          <i className="ri-map-pin-2-fill" />
        </span>
      </div>

      <div className="relative grid gap-8 p-7 sm:p-10 lg:grid-cols-[minmax(0,26rem)_1fr] lg:py-12">
        <div>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-sky-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-300 opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-sky-300" />
            </span>
            {t('footer.location.eyebrow')}
          </p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-white">{t('footer.location.hq')}</p>

          <address className="mt-4 text-[15px] not-italic leading-relaxed text-slate-300">
            {HQ.lines.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
            <span className="block font-semibold text-white">{HQ.city}</span>
          </address>

          <a href={`mailto:${HQ.email}`} className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-white">
            <i className="ri-mail-line text-base text-sky-300" aria-hidden />
            {HQ.email}
          </a>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href={HQ.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 rounded-xl bg-white px-4 py-2.5 text-sm font-semibold text-[#0b3fb4] shadow-lg shadow-black/30 transition-colors hover:bg-blue-50"
            >
              {t('footer.location.cta')}
              <i className="ri-arrow-right-up-line" aria-hidden />
            </a>
            <Link to="/contact" className="inline-flex items-center gap-1.5 rounded-xl border border-white/30 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10">
              {t('footer.location.contact')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
